import {
  Container,
  Row,
  Col,
  Button,
  Stack,
  Text,
  Visible
} from '@leroy-merlin-br/backyard-react-ui'

import { GenericCarousel } from 'reactGarden/GenericCarousel'

import { Icon } from '../../components/Icon'
import * as S from './styled'

const CARDS = [
  {
    icon: 'coupon',
    title: 'Cupons de Desconto',
    text: 'Cupons diários personalizados para o seu perfil'
  },
  {
    icon: 'gift',
    title: 'Surpresa de Aniversário',
    text: 'Presente especial no mês do seu aniversário'
  },
  {
    icon: 'calendar',
    title: 'Eventos Imperdíveis',
    text: 'Seu lugar garantido em eventos'
  },
  {
    icon: 'course',
    title: 'Cursos e Workshops',
    text: 'Aprenda a personalizar sua casa do jeito certo'
  },
  {
    icon: 'content',
    title: 'Conteúdos Exclusivos',
    text: 'Dicas e matérias que realmente interessam'
  }
]

const ListOfCards = () =>
  CARDS.map(({ icon, title, text }) => (
    <S.Card key={`slide-${title}`}>
      <Icon name={icon} />
      <S.CardTitle size="mega">{title}</S.CardTitle>
      <Text size="kilo">{text}</Text>
    </S.Card>
  ))

const MobileShelf = () => {
  const swiperOptions = {
    slidesPerView: 'auto',
    spaceBetween: 48
  }

  return <GenericCarousel {...swiperOptions}>{ListOfCards()}</GenericCarousel>
}

const Section = () => (
  <S.Section>
    <Container>
      <Col size={{ giga: 10 }} offset={{ giga: 1 }}>
        <Stack spacing="exa">
          <S.SectionTitle size="tera" noMargin>
            Quais as vantagens?
          </S.SectionTitle>

          <Row justify="space-between" noGutters>
            <Visible untilKilo kilo mega>
              <MobileShelf />
            </Visible>
            <Visible giga tera>
              <ListOfCards />
            </Visible>
          </Row>

          <Container>
            <Row justify="center">
              <Button as="a" href="/fidelidade/participar" size="mega">
                Começar a aproveitar
              </Button>
            </Row>
          </Container>
        </Stack>
      </Col>
    </Container>
  </S.Section>
)

export default Section
